import * as angular from 'angular';

class BidUpgradeLabelComponentCtrl implements ng.IController {}

angular.module('app').component('pkpBidUpgradeLabel', {
    controller: BidUpgradeLabelComponentCtrl,
    template: require('app/auction-bid/bid-upgrade-label.html'),
    bindings: {}
});
